export default __webpack_public_path__ + "images/loggedout/home/modularPage/games-f5d3100b99a39ef8c48f5445c7f3eb7e.png";